/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.37
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Problem } from '../model/models';
import { TripV2 } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class ArchiveV2Service {

    protected basePath = 'https://journey-service.api.sbb.ch';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Returns PDF with matching delayed connection. Recorded back to 30 days ago, captured at arrival time for various &#x60;Operator\&#39;s&#x60;.
     * @param archiveDate Day of operation.
     * @param journeyId Given by Journey::journeyId (v3.DatedVehicleJourney::id or v2.JourneyDetail::journeyReference) in preceeding request to /delayConfirmation/{archiveDate}
     * @param stationUIC DiDok code (UIC) of a station.
     * @param transportProductName Transport-product name
     * @param acceptLanguage Language of translatable properties.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation(archiveDate: string, journeyId: string, stationUIC: number, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<string>;
    public getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation(archiveDate: string, journeyId: string, stationUIC: number, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<string>>;
    public getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation(archiveDate: string, journeyId: string, stationUIC: number, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<string>>;
    public getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation(archiveDate: string, journeyId: string, stationUIC: number, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (archiveDate === null || archiveDate === undefined) {
            throw new Error('Required parameter archiveDate was null or undefined when calling getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation.');
        }
        if (journeyId === null || journeyId === undefined) {
            throw new Error('Required parameter journeyId was null or undefined when calling getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation.');
        }
        if (stationUIC === null || stationUIC === undefined) {
            throw new Error('Required parameter stationUIC was null or undefined when calling getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation.');
        }
        if (transportProductName === null || transportProductName === undefined) {
            throw new Error('Required parameter transportProductName was null or undefined when calling getDelayConfirmationByDateAndJourneyIdAndTransportProductNameAndStation.');
        }

        let headers = this.defaultHeaders;
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<string>(`${this.configuration.basePath}/b2c/v2/delayConfirmation/${encodeURIComponent(String(archiveDate))}/${encodeURIComponent(String(journeyId))}/${encodeURIComponent(String(transportProductName))}/${encodeURIComponent(String(stationUIC))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns a list with delayed connections for given train name (e.g. \&#39;IC 728\&#39;). Non-delayed are not returned. Recorded back to 30 days ago, captured at arrival time for various &#x60;Operator\&#39;s&#x60;.
     * @param archiveDate Day of operation.
     * @param transportProductName Transport-product name consisting strictly of 3 parts: category, line, number
     * @param acceptLanguage Language of translatable properties.
     * @param requestID The given \&#39;Request-ID\&#39; will support traceability (monitoring by Instana and logging by Splunk). The given value will be returned by the appropriate response as well (see [SBB Instana](https://confluence.sbb.ch/display/MON/Instana+-+HTTP+Header+Whitelist)).
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @deprecated
     */
    public getDelayConfirmationByDateAndTransportProductName(archiveDate: string, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<Array<TripV2>>;
    public getDelayConfirmationByDateAndTransportProductName(archiveDate: string, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpResponse<Array<TripV2>>>;
    public getDelayConfirmationByDateAndTransportProductName(archiveDate: string, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<HttpEvent<Array<TripV2>>>;
    public getDelayConfirmationByDateAndTransportProductName(archiveDate: string, transportProductName: string, acceptLanguage?: 'de' | 'fr' | 'it' | 'en', requestID?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json'}): Observable<any> {
        if (archiveDate === null || archiveDate === undefined) {
            throw new Error('Required parameter archiveDate was null or undefined when calling getDelayConfirmationByDateAndTransportProductName.');
        }
        if (transportProductName === null || transportProductName === undefined) {
            throw new Error('Required parameter transportProductName was null or undefined when calling getDelayConfirmationByDateAndTransportProductName.');
        }

        let headers = this.defaultHeaders;
        if (acceptLanguage !== undefined && acceptLanguage !== null) {
            headers = headers.set('Accept-Language', String(acceptLanguage));
        }
        if (requestID !== undefined && requestID !== null) {
            headers = headers.set('Request-ID', String(requestID));
        }

        let credential: string | undefined;
        // authentication (BearerAuth) required
        credential = this.configuration.lookupCredential('BearerAuth');
        if (credential) {
            headers = headers.set('Authorization', 'Bearer ' + credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<TripV2>>(`${this.configuration.basePath}/b2c/v2/delayConfirmation/${encodeURIComponent(String(archiveDate))}/${encodeURIComponent(String(transportProductName))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
